import React from 'react';
import { formatEuro } from '@/lib/format';
import { WORKFLOW_LABEL } from '@/lib/packages/service';

const WF_TONE = {
  budgeted: 'border-border text-muted-foreground', quoting: 'border-sky-300 text-sky-800', quote_selected: 'border-sky-400 text-sky-900',
  partially_awarded: 'border-amber-300 text-amber-800', awarded: 'border-emerald-300 text-emerald-800', in_progress: 'border-bronze/60 text-bronze',
  final_account: 'border-charcoal/40 text-charcoal', closed: 'border-border text-muted-foreground bg-ivory/60',
};
export const WorkflowPill = ({ value, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] uppercase tracking-wider bg-white whitespace-nowrap ${WF_TONE[value] || 'border-border text-charcoal'}`}>{WORKFLOW_LABEL[value] || value}</span>
);

export const Variance = ({ value, testId }) => {
  const v = Number(value || 0);
  return <span data-testid={testId} className={`tabular-nums font-medium ${v < 0 ? 'text-red-800' : v > 0 ? 'text-emerald-800' : 'text-muted-foreground'}`}>{v < 0 ? `(${formatEuro(-v)})` : formatEuro(v)}</span>;
};

const Dot = ({ tone, label, testId }) => <span data-testid={testId} className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wider ${tone}`}>{label}</span>;
export const Indicators = ({ r, testId }) => (
  <div className="flex flex-wrap gap-1" data-testid={testId}>
    {r.over_budget && <Dot tone="bg-red-50 text-red-800" label="Over budget" testId={`${r.code}-ind-over`} />}
    {r.under_budget && <Dot tone="bg-emerald-50 text-emerald-800" label="Under budget" testId={`${r.code}-ind-under`} />}
    {r.scope_incomplete && <Dot tone="bg-amber-50 text-amber-800" label="Scope incomplete" testId={`${r.code}-ind-scope`} />}
    {r.variation_pending && <Dot tone="bg-sky-50 text-sky-800" label="Variation pending" testId={`${r.code}-ind-var`} />}
    {r.closure_exception && <Dot tone="bg-ivory text-charcoal" label="Closed by exception" />}
  </div>
);
